<template>
    <div class="home-tab">
        <ul class="tabs tab-link current home-tabs" style="overflow-x: scroll">
            <template v-for="(category, index) in secondListCategories" :key="index">
                <li
                    @click="stopAutoScroll"
                    class="tab-link"
                    :class="{ 'current': index === currentTab }"
                    :data-tab="category.slug"
                    v-if="!($store.state.language.code === 'tr' && category.slug === 'the-war-front')"

                >
                    {{ category.category_languages[0].pivot.name }}

                </li>
            </template>
        </ul>
        <template v-for="(category, index) in secondListCategories" :key="index">
            <div
                :id="category.slug"
                class="tab-content"
                :class="{'current': index === currentTab}"
            >
                <div class="row"
                     v-if="category.articles.length > 0 && !($store.state.language.code === 'tr' && category.slug === 'the-war-front')">
                    <div class="col-md-6 col-sm-12">
                        <second-slider-main-article :article="category.articles[0]"></second-slider-main-article>
                    </div>
                    <div class="col-md-6  col-sm-12">
                        <template v-for="(article, index) in category.articles">
                            <second-slider-article
                                v-if="index > 0"
                                :article="article"></second-slider-article>
                        </template>
                    </div>

                </div>
                <div class="view-more">
                    <span><a :href="$store.state.hrefPrefix + '/category/' + category.slug">{{
                            $t("view_more")
                        }}</a></span>
                </div>
            </div>
        </template>

    </div>
</template>

<script>


import SecondSliderArticle from "@/parts/home/slider/SecondSliderArticle.vue";
import SecondSliderMainArticle from "@/parts/home/slider/SecondSliderMainArticle.vue";

export default {
    name: "HomeTab",
    components: {SecondSliderMainArticle, SecondSliderArticle},
    props: {
        secondListCategories: {
            type: Array,
            default: [],
        },
    },


    data() {
        return {
            currentTab: 0,
            intervalId: null,

        };
    },

    mounted() {
        this.startAutoScroll();


    },

    methods: {
        startAutoScroll() {
            this.intervalId = setInterval(() => {
                this.currentTab = (this.currentTab + 1) % this.secondListCategories.length;
            }, 10000);
        },
        stopAutoScroll() {
            clearInterval(this.intervalId);
        },
    },
};
</script>

<style scoped>
.home-tabs::-webkit-scrollbar {
    display: none;
}
</style>
